module.exports = __webpack_public_path__ + "static/media/sastra-login-banner1.84ec407c.jpg";